module.exports = __webpack_public_path__ + "img/tasks_green.ff3ff033.png";